export const HighlightBorder = ({ schema, rowIndex, colIndex }) => {
  const rowLength = schema.yTicks.length
  const colLength = schema.xTicks.length

  const getStyleBorderTop = () => {
    if (rowLength !== 10 && colLength !== 10) {
      if (
        (rowIndex === rowLength - 4 &&
          colIndex > colLength - 5 &&
          colIndex < colLength - 1) ||
        (rowIndex === rowLength - 1 &&
          colIndex > colLength - 5 &&
          colIndex < colLength - 2) ||
        (rowIndex === rowLength - 2 && colIndex === colLength - 2)
      ) {
        return { top: -2, left: -2, width: 'calc(100% + 4px)', height: 2 }
      }
    } else {
      if (rowLength === 10) {
        if (
          (rowIndex === rowLength - 6 &&
            colIndex > colLength - 5 &&
            colIndex < colLength - 1) ||
          (rowIndex === rowLength - 1 &&
            colIndex > colLength - 5 &&
            colIndex < colLength - 2) ||
          (rowIndex === rowLength - 2 && colIndex === colLength - 2)
        ) {
          return { top: -2, left: -2, width: 'calc(100% + 4px)', height: 2 }
        }
      }
      if (colLength === 10) {
        if (
          (rowIndex === rowLength - 4 &&
            colIndex > colLength - 7 &&
            colIndex < colLength - 1) ||
          (rowIndex === rowLength - 1 &&
            colIndex > colLength - 7 &&
            colIndex < colLength - 2) ||
          (rowIndex === rowLength - 2 && colIndex === colLength - 2)
        ) {
          return { top: -2, left: -2, width: 'calc(100% + 4px)', height: 2 }
        }
      }
    }
  }

  const getStyleBorderLeft = () => {
    if (rowLength !== 10 && colLength !== 10) {
      if (
        (colIndex === colLength - 4 &&
          rowIndex > rowLength - 5 &&
          rowIndex < rowLength - 1) ||
        (colIndex === colLength - 1 &&
          rowIndex > rowLength - 5 &&
          rowIndex < rowLength - 2) ||
        (colIndex === colLength - 2 && rowIndex === rowLength - 2)
      ) {
        return { top: -2, left: -2, width: 2, height: 'calc(100% + 4px)' }
      }
    } else {
      if (rowLength === 10) {
        if (
          (colIndex === colLength - 4 &&
            rowIndex > rowLength - 7 &&
            rowIndex < rowLength - 1) ||
          (colIndex === colLength - 1 &&
            rowIndex > rowLength - 7 &&
            rowIndex < rowLength - 2) ||
          (colIndex === colLength - 2 && rowIndex === rowLength - 2)
        ) {
          return { top: -2, left: -2, width: 2, height: 'calc(100% + 4px)' }
        }
      }
      if (colLength === 10) {
        if (
          (colIndex === colLength - 6 &&
            rowIndex > rowLength - 5 &&
            rowIndex < rowLength - 1) ||
          (colIndex === colLength - 1 &&
            rowIndex > rowLength - 5 &&
            rowIndex < rowLength - 2) ||
          (colIndex === colLength - 2 && rowIndex === rowLength - 2)
        ) {
          return { top: -2, left: -2, width: 2, height: 'calc(100% + 4px)' }
        }
      }
    }
  }

  return (
    <>
      <div
        className="positionAbsolute"
        style={{ backgroundColor: '#2C73E8', ...getStyleBorderTop() }}
      />
      <div
        className="positionAbsolute"
        style={{ backgroundColor: '#2C73E8', ...getStyleBorderLeft() }}
      />
    </>
  )
}
